import { render } from "./HeroiconsOutlineDeviceMobile.vue?vue&type=template&id=f3c4435e"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDeviceMobile.vue"]])

export default __exports__